import {Toast} from 'vant';
import Clipboard from 'clipboard';

const sensors = {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.newTime = new Date().getTime()
        })
    },
    beforeRouteLeave(to, from, next) {
        !this.isOld && this.leavePage();
        next();
    },
    beforeRouteUpdate(to, from, next) {
        !this.isOld && this.leavePage();
        next();
    },
    
    data() {
        return {
            pageTitle: this.$route.meta.title,
            newTime: '',
        }
    },
    created () {
        const that = this;
        if(!this.isOld) {
            this.onTrack('mkt_page_show', {
                mkt_page_title: this.pageTitle,
            })
            window.addEventListener('beforeunload', e => {
                that.leavePage();
            });
        }
    },
    destroyed () {
        !this.isOld && this.leavePage();
    },
    methods: {
        leavePage() {
            const currentDate = new Date().getTime() - this.newTime;
            this.onTrack('mkt_page_view', {
                mkt_view_duration: currentDate / 1000,
                mkt_page_title: this.pageTitle,
            })
        },
        onTrack(name, params) {
            this.$sensors.track(name, params)
        },
    },
};
const copyWechat = {
    methods: {
        handleCopy(text) {
            let clipboard = new Clipboard('.needCopyBtn', {
                text: function () {
                    return text;
                }
            })
            clipboard.on('success', e => {
                Toast({
                    message: '复制成功',
                    duration: 1000,
                });
                // 释放内存
                clipboard.destroy();
            })
            clipboard.on('error', e => {
                Toast({
                    message: '复制失败',
                    duration: 1000,
                });
                clipboard.destroy();
            })
        },
    },
}
export {
    sensors,
    copyWechat,
}